import React from 'react'
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact/toast'
import { AssignmentExecutionResults } from './AssignmentExecutionResults'
import { ExecutionSuccessDialog } from './ExecutionSuccessDialog'
import { OrderProcessingInitialView } from './OrderProcessingInitialView'
import { useBulkOrderAssignment } from '../../../hooks/useBulkOrderAssignment'
import '../../../css/BulkOrderAssignmentDialog.css'
import { useOrderData } from '../../../hooks/useOrderData'
import { useLineItems } from '../../../hooks/useLineItems'
import { useOrderSelection } from '../../../hooks/useOrderSelection'
import { useLineItemSelection } from '../../../hooks/useLineItemSelection'

interface BulkOrderAssignmentDialogProps {
  visible: boolean
  onCloseDialog: () => void
  orderData: ReturnType<typeof useOrderData>
  orderSelection: ReturnType<typeof useOrderSelection>
  lineItemsHook: ReturnType<typeof useLineItems>
  lineItemSelection: ReturnType<typeof useLineItemSelection>
}

export const BulkOrderAssignmentDialog: React.FC<BulkOrderAssignmentDialogProps> = ({
  orderData,
  orderSelection,
  lineItemsHook,
  lineItemSelection,
  visible,
  onCloseDialog,
}) => {
  const bulkOrderAssignment = useBulkOrderAssignment(orderData.refresh)

  const onProcessOrders = async () => {
    const orders = orderSelection.getSelectedOrdersData()
    await bulkOrderAssignment.handleProcessOrders(orders)
  }


  const getDialogHeader = () => {
    if (bulkOrderAssignment.currentStep === 'success') {
      return (
        <div className="flex align-items-center gap-2">
          <i className="pi pi-check-circle text-green-600" style={{ fontSize: '1.25rem', marginRight: '8px' }}></i>
          <span>Assignment Complete</span>
        </div>
      )
    }
    
    return (
      <div className="flex align-items-center gap-2">
        <i className="pi pi-cog text-primary" style={{ fontSize: '1.25rem', marginRight: '8px' }}></i>
        <span>Bulk Order Assignment</span>
      </div>
    )
  }

  const renderDialogContent = () => {
    switch (bulkOrderAssignment.currentStep) {
      case 'initial':
        return (
          <OrderProcessingInitialView
            orderSelection={orderSelection}
            lineItemsHook={lineItemsHook}
            lineItemSelection={lineItemSelection}
            onProcessOrders={onProcessOrders}
            onCloseDialog={onCloseDialog}
          />
        )
      
      case 'results':
        return (
          <AssignmentExecutionResults
            orderData={orderData}
            orderSelection={orderSelection}
            lineItemsHook={lineItemsHook}
            BulkOrderAssignment={bulkOrderAssignment}
            lineItemSelection={lineItemSelection}
          />
        )
      
      case 'success':
        return (
          <ExecutionSuccessDialog
            useBulkOrderAssignment={bulkOrderAssignment}
            orderData={orderData}
            orderSelection={orderSelection}
            lineItemsHook={lineItemsHook}
            lineItemSelection={lineItemSelection}
            onCloseDialog={() => {
              onCloseDialog()
              bulkOrderAssignment.resetState()
            }}
          />
        )
      
      default:
        return null
    }
  }

  return (
    <>
      <Toast ref={bulkOrderAssignment.toast} />
      <Dialog
        visible={visible}
        onHide={() => {
          onCloseDialog()
          bulkOrderAssignment.resetState()
        }}
        header={getDialogHeader()}
        style={{ width: '900px' }}
        modal
        contentClassName="flex flex-direction-column"
      >
        {renderDialogContent()}
      </Dialog>
    </>
  )
}